var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating"},_vm._l((5),function(index){return _c('span',{key:'rating_' + index,staticClass:"rating__item",class:{ 'is-rated': index <= _vm.rating }})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c8cbaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ratings/RatingStars.vue
// module id = 904
// module chunks = 93